import React from 'react'
import PropTypes from 'prop-types'

const SECTION_SELECTOR = 'details.detail-section'

// A jump target is either one section or a row of them; open whatever is
// collapsed there so the jump lands on content, not a closed header.
const openSectionsIn = (element) => {
  const sections = element.matches(SECTION_SELECTOR)
    ? [element]
    : element.querySelectorAll(SECTION_SELECTOR)
  sections.forEach((section) => {
    section.open = true
  })
}

// Each section's own onToggle keeps its React state in step.
const setAllSections = (isOpen) => {
  document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
    section.open = isOpen
  })
}

// Sticky row of links to the sections of a long detail screen. The app routes
// on the URL hash, so a plain href="#section" would navigate away; scroll
// instead.
const DetailJumpNavComponent = ({ sections }) => {
  const handleJump = (event, id) => {
    event.preventDefault()
    const element = document.getElementById(id)
    if (element) {
      openSectionsIn(element)
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <nav className="detail-nav mb-4">
      {sections.map((section) => (
        <button
          key={section.id}
          type="button"
          className="btn btn-sm btn-link"
          onClick={(event) => handleJump(event, section.id)}
        >
          {section.label}
        </button>
      ))}
      <span className="ms-auto">
        <button
          type="button"
          className="btn btn-sm btn-link text-muted"
          onClick={() => setAllSections(true)}
        >
          Expand all
        </button>
        <button
          type="button"
          className="btn btn-sm btn-link text-muted"
          onClick={() => setAllSections(false)}
        >
          Collapse all
        </button>
      </span>
    </nav>
  )
}

DetailJumpNavComponent.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
}

export default DetailJumpNavComponent
